export class DeleteRecordByIdSectorUseCase{
  constructor(repository){
    this.repository=repository
  }

  async execute(ID_SECTOR){
    const hasRegisters=await this.repository.checkIfEmpty(ID_SECTOR)
    if(hasRegisters){
      return await this.repository.deleteByIdSector(ID_SECTOR)
    }
  }
}
